import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import SwitchField from "components/SwitchField";
import { memo } from "react";
import FormNumberField from "components/FormNumberField";

/* eslint-disable react/prop-types */

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    settlement,
    year,
    firstTime,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxpayerInstead,
    taxpayerInsteadId,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
      <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={settlement.name}
            label={settlement.label}
            value={values.settlement}
            error={errors.settlement && touched.settlement}
            success={
              values.settlement?.toString().length > 0 && !errors.settlement
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
        <FormNumberField
            name={year.name}
            label={year.label}
            value={values.year}
            error={errors.year && touched.year}
            success={
              values.year?.toString().length > 0 && !errors.year
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerInstead.name}
            label={taxpayerInstead.label}
            value={values.taxpayerInstead}
            error={errors.taxpayerInstead && touched.taxpayerInstead}
            success={values.taxpayerInstead?.toString().length > 0 && !errors.taxpayerInstead}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerInsteadId.name}
            label={taxpayerInsteadId.label}
            value={values.taxpayerInsteadId}
            error={errors.taxpayerInsteadId && touched.taxpayerInsteadId}
            success={values.taxpayerInsteadId?.toString().length > 0 && !errors.taxpayerInsteadId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={
              values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={
              values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}


Fields.displayName = "Fields";

export default memo(Fields);